module.exports = "/assets/data/fc9a6bd04546828a6eed890d6d0c886e-L17.data.json";